module.exports = __webpack_public_path__ + "img/boleyn-traitor.a4e9c1c3.png";